import React, { FC, forwardRef, useImperativeHandle } from 'react';
import { SwitchChangeEventHandler, SwitchClickEventHandler, SwitchProps } from 'antd/lib/switch';
import { Switch } from 'antd';
import cx from 'classnames';
import './Switch.scss';

interface SwitchRef {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: SwitchChangeEventHandler;
  onClick?: SwitchClickEventHandler;
}
const CustomSwitch: FC<SwitchProps> = forwardRef<SwitchRef, SwitchProps>((props, ref) => {
  const { className, checked, defaultChecked, onChange, onClick, ...res } = props;

  useImperativeHandle(ref, () => ({
    checked,
    defaultChecked,
    onChange,
    onClick,
  }));

  return (
    <Switch
      className={cx('amondz-switch', className)}
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={onChange}
      onClick={onClick}
      {...res}
    />
  );
});
CustomSwitch.displayName = 'CustomSwitch';

export default CustomSwitch;
